import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import Logo from '../assets/LogoFooter.svg';
import { FaLinkedin, FaInstagram, FaFacebook, FaEnvelope, FaPhone, FaMapMarkerAlt, FaArrowRight } from 'react-icons/fa';
import './Footer.css';

const Footer = () => {
  const { t, i18n } = useTranslation();

  return (
    <footer className="footer">
      {/* Decorative top border/gradient */}
      <div className="footer-gradient-border"></div>
      
      <div className="footer-container">
        <div className="footer-grid">
          {/* Brand Section */}
          <div className="footer-section brand-section">
            <Link to="/" className="footer-logo">
              <img src={Logo} alt="MyWebify" className="footer-logo-image" />
            </Link>
            <p className="footer-description">
              {t('footer.description')}
            </p>
            <div className="social-links">
              <a href="https://www.linkedin.com/company/lusciousweb" target="_blank" rel="noopener noreferrer" className="social-icon" aria-label="LinkedIn">
                <FaLinkedin />
              </a>
              <a href="https://www.instagram.com/luscious.be?igsh=MTZ1cDl3cng2Ym1naQ==" target="_blank" rel="noopener noreferrer" className="social-icon" aria-label="Instagram">
                <FaInstagram />
              </a>
              <a href="https://facebook.com" target="_blank" rel="noopener noreferrer" className="social-icon" aria-label="Facebook">
                <FaFacebook />
              </a>
            </div>
            <div className="footer-lang-switcher">
              <label htmlFor="language-select" className="lang-label">{t('footer.language', 'Taal')}:</label>
              <select 
                id="language-select"
                className="footer-lang-select" 
                value={i18n.language} 
                onChange={(e) => i18n.changeLanguage(e.target.value)}
              >
                <option value="nl">Nederlands (NL)</option>
                <option value="en">English (EN)</option>
                {/* Add more languages here */}
              </select>
            </div>
          </div>

          {/* Navigation Links */}
          <div className="footer-section">
            <h4 className="footer-heading">{t('footer.navigation')}</h4>
            <ul className="footer-links">
              <li><Link to="/"><FaArrowRight className="link-icon" /> {t('navbar.home')}</Link></li>
              <li><Link to="/diensten"><FaArrowRight className="link-icon" /> {t('navbar.services')}</Link></li>
              <li><Link to="/portfolio"><FaArrowRight className="link-icon" /> {t('navbar.portfolio')}</Link></li>
              <li><Link to="/prijzen"><FaArrowRight className="link-icon" /> {t('navbar.prices')}</Link></li>
              {/*<li><Link to="/offerte"><FaArrowRight className="link-icon" /> Offerte</Link></li> */}
              <li><Link to="/contact"><FaArrowRight className="link-icon" /> {t('navbar.contact')}</Link></li>
            </ul>
          </div>

          {/* Legal Links */}
          <div className="footer-section">
            <h4 className="footer-heading">{t('footer.legal')}</h4>
            <ul className="footer-links">
              <li><Link to="/privacy"><FaArrowRight className="link-icon" /> {t('footer.privacy')}</Link></li>
              <li><Link to="/cookies"><FaArrowRight className="link-icon" /> {t('footer.cookies')}</Link></li>
              <li><Link to="/voorwaarden"><FaArrowRight className="link-icon" /> {t('footer.terms')}</Link></li>
            </ul>
          </div>

          {/* Contact Info */}
          <div className="footer-section">
            <h4 className="footer-heading">{t('footer.contact')}</h4>
            <ul className="footer-contact-info">
              <li>
                <div className="contact-icon-wrapper">
                  <FaEnvelope />
                </div>
                <a href="mailto:Info@luscious.be">Info@luscious.be</a>
              </li>
              <li> {/*
                <div className="contact-icon-wrapper">
                  <FaPhone />
                </div>
                <a href="tel:+32412345678">+32 4 12 34 56 78</a> */}
              </li>
              <li>
                <div className="contact-icon-wrapper">
                  <FaMapMarkerAlt />
                </div>
                <span>België</span>
              </li>
              <li> {/*
                <div className="contact-icon-wrapper" style={{ fontSize: '0.9em', fontWeight: 'bold' }}>
                  BTW
                </div>
                 <span>BE 0123.456.789</span> */}
              </li>
            </ul>
          </div>
        </div>

        <div className="footer-bottom">
          <div className="footer-bottom-content">
            <p>&copy; {new Date().getFullYear()} Luscious {t('footer.rights')}</p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
